import React from 'react';
import { Card, Table, Space, Button, Tag } from 'antd';
import { FileTextOutlined, SettingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { PAYMENT_STATUS_COLORS } from '../constants';

const PaymentHistory = ({ 
  payments, 
  loading, 
  pagination, 
  onTableChange, 
  onViewPaymentDetails,
  cardStyle 
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('date'),
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: t('total'),
      dataIndex: 'total',
      key: 'total',
    },
    {
      title: t('coins'),
      dataIndex: 'coins',
      key: 'coins',
    },
    {
      title: t('status'),
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag
          color={PAYMENT_STATUS_COLORS[status] || PAYMENT_STATUS_COLORS.default}
          style={{ textTransform: 'capitalize' }}
        >
          {status || 'N/A'}
        </Tag>
      ),
    },
    {
      title: t('actions'),
      key: 'actions',
      width: 100,
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<FileTextOutlined />}
            href={record.invoice_url}
            disabled={!record.invoice_url}
            target="_blank"
          >
            {t('view')}
          </Button>
          <Button
            type="link"
            icon={<SettingOutlined />}
            onClick={() => onViewPaymentDetails(record)}
          >
            {t('details')}
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Card style={cardStyle} title={t('invoice_history')}>
      <div style={{ overflowX: 'auto' }}>
        <Table
          columns={columns}
          dataSource={payments}
          loading={loading}
          pagination={{
            ...pagination,
            pageSizeOptions: [10, 25, 50, 100],
            showSizeChanger: true,
            showTotal: (total) => `${t('total')} ${total} ${t('items')}`,
          }}
          onChange={onTableChange}
        />
      </div>
    </Card>
  );
};

export default PaymentHistory; 